<template>
 <b-row>
    <b-col cols="12">
      <b-jumbotron>
        <b-form @submit="onSubmit">
          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="First Name:">
            <b-form-input required id="first_name" v-model.trim="member.first_name"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Last Name:">
              <b-form-input required id="last_name" v-model.trim="member.last_name"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Address Line 1:">
            <b-form-input required id="address_1" v-model.trim="member.address_1"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Address Line 2:">
            <b-form-input id="address_2" v-model.trim="member.address_2"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="City:">
            <b-form-input required id="city" v-model.trim="member.city"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Post Code:">
            <b-form-input required id="postcode" v-model.trim="member.postcode"></b-form-input>
          </b-form-group>

          <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Contact No.:">
            <b-form-input required id="mobile_no" v-model.trim="member.mobile_no"></b-form-input>
          </b-form-group>

        <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Membership Level:">
            <b-form-select required id="membership" v-model.trim="member.membership">
              <option value="Standard">Standard</option>
              <option value="Student">Student</option>
            </b-form-select>
        </b-form-group>

        <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="On Probation?">
          <b-form-group required class="yes-no-buttons">
            <b-form-checkbox button button-variant="outline-info" class="yes-button" inline v-model.trim="member.probation" value="Yes">Yes</b-form-checkbox>
            <b-form-checkbox button button-variant="outline-info" class="no-checkbox" inline v-model.trim="member.probation" value="No">No</b-form-checkbox>
          </b-form-group>
        </b-form-group>

            <b-form-group id="fieldsetHorizontal"
                    horizontal
                    :label-cols="4"
                    breakpoint="md"
                    label="Member Since:">
            <b-form-input required type="date" id="member_since" v-model.trim="member.member_since"></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="success" class="save-btn">Save</b-button>
          <b-btn class="cancel-btn" variant="primary" @click.stop="showmember(key)">Cancel</b-btn>
        </b-form>
      </b-jumbotron>
    </b-col>
  </b-row>
</template>

<script>

import firebase from '../Firebase'
import router from '../router/index.js'

export default {
  name: 'EditMember',
  data () {
    return {
      key: this.$route.params.id,
      member: {},
      scrolled: false
    }
  },
  created () {
    const ref = firebase.firestore().collection('members').doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.member = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      const updateRef = firebase.firestore().collection('members').doc(this.$route.params.id);
      updateRef.set(this.member).then((docRef) => {
        this.key = ''
        this.member.first_name = ''
        this.member.last_name = ''
        this.member.address_1 = ''
        this.member.address_2 = '' 
        this.member.city = '' 
        this.member.postcode = ''
        this.member.mobile_no = ''
        this.member.membership = ''
        this.member.probation = ''
        this.member.member_since = ''
        router.push({ name: 'ShowMember', params: { id: this.$route.params.id }})
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    },

    showmember (id) {
      router.push({
        name: 'ShowMember',
        params: { id: id }
      })
    },

    deletemember (id) {
      firebase.firestore().collection('members').doc(id).delete().then(() => {
        router.push({
          name: 'MemberList'
        })
      }).catch((error) => {
        alert("Error removing document: ", error);
      });
    },
  }
}
</script>

<style>
  .submit-btn {
    margin-right: 20px;
  }
  .save-btn {
    margin-right: 20px;
  }
  .cancel-btn {
    margin-right: 20px;
  }
 .yes-no-buttons {
   text-align: left;
 }
 .yes-button {
   margin-right: 15px;
 }
  .jumbotron {
    padding: 2rem;
  }
</style>